import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './core-6f498fd9.js';
var CsmDroppableArea = /** @class */ (function () {
    function CsmDroppableArea(hostRef) {
        registerInstance(this, hostRef);
        this.csmDroppableDrop = createEvent(this, "csmDroppableDrop", 7);
    }
    CsmDroppableArea.prototype.componentDidLoad = function () {
        this.droppableElement.addEventListener('dragenter', this.onDragEnter.bind(this));
        this.maskElement.addEventListener('dragover', this.onDragOver.bind(this));
        this.maskElement.addEventListener('dragleave', this.onDragLeave.bind(this));
        this.maskElement.addEventListener('drop', this.onDrop.bind(this));
    };
    CsmDroppableArea.prototype.componentDidUnload = function () {
        this.droppableElement.removeEventListener('dragenter', this.onDragEnter.bind(this));
        this.maskElement.removeEventListener('dragover', this.onDragOver.bind(this));
        this.maskElement.removeEventListener('dragleave', this.onDragLeave.bind(this));
        this.maskElement.removeEventListener('drop', this.onDrop.bind(this));
    };
    CsmDroppableArea.prototype.onDragEnter = function (event) {
        console.log('onDragEnter');
        if (event.dataTransfer.types.includes('csm-dragndrop-type')) {
            // prevent the default handling by cancelling the event to allow a drop
            event.preventDefault();
            this.droppableElement.classList.add('is-dropping');
        }
    };
    CsmDroppableArea.prototype.onDragOver = function (event) {
        if (event.dataTransfer.types.includes('csm-dragndrop-type')) {
            // prevent the default handling by cancelling the event to allow a drop
            event.preventDefault();
        }
    };
    CsmDroppableArea.prototype.onDragLeave = function () {
        this.droppableElement.classList.remove('is-dropping');
    };
    CsmDroppableArea.prototype.onDrop = function (event) {
        // prevent the default handling by cancelling the event to allow a drop
        event.preventDefault();
        this.droppableElement.classList.remove('is-dropping');
        console.log(event.dataTransfer.getData('csm-dragndrop-type'));
        this.csmDroppableDrop.emit({
            draggedHTML: event.dataTransfer.getData('csm-dragndrop-type'),
            dropTarget: this.droppableElement,
        });
    };
    CsmDroppableArea.prototype.render = function () {
        var _this = this;
        return (h(Host, { group: this.group }, h("slot", null), h("div", { class: "mask", ref: function (el) { return (_this.maskElement = el); } })));
    };
    Object.defineProperty(CsmDroppableArea.prototype, "droppableElement", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmDroppableArea, "style", {
        get: function () { return "\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:400;src:url(../assets/fonts/ProximaNova-Regular.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Regular.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:600;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:700;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:900;src:url(../assets/fonts/ProximaNova-Black.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Black.woff) format(\"woff\")}\@font-face{font-family:CS-FontIcon-v19;src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb);src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb#iefix) format(\"embedded-opentype\"),url(../assets/icons/CS-FontIcon-v19.ttf?cz1hbb) format(\"truetype\"),url(../assets/icons/CS-FontIcon-v19.woff?cz1hbb) format(\"woff\"),url(../assets/icons/CS-FontIcon-v19.svg?cz1hbb#CS-FontIcon-v18) format(\"svg\");font-weight:400;font-style:normal;font-display:block}:root{font-family:Proxima Nova,sans-serif}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:inherit}:host{display:block;height:100%;position:relative}:host .mask{position:absolute;height:100%;width:100%;top:-1em;left:-1em;padding:1em;opacity:.5;display:none}:host(.is-dropping){background-color:#4b8ae7}:host(.is-dropping) .mask{display:block}"; },
        enumerable: true,
        configurable: true
    });
    return CsmDroppableArea;
}());
export { CsmDroppableArea as csm_droppable_area };
